import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import sanitizeHtml from "sanitize-html";

const TitleCell: FC<Props> = ({ element }) => {

  return (
    <div className={styles.wrapper}>
      <div
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(element.Title),
        }}
      ></div>
    </div>
  );
};

export default TitleCell;
